import PaginationState, { EmptyPagination } from '../pagination/state/pagination-state';
import DataState from '../data/state/data-state';
import JobsState from '../jobs/state/jobs-state';
import FiltersState from '../filters/state/filters-state';
import ConfigState from '../config/state/config-state';
import { DefaultConfig } from '../config/types/config';

interface State {
  config: ConfigState;
  data: DataState;
  filters: FiltersState;
  pagination: PaginationState;
  jobs: JobsState;
}

export const Initial: State = {
  config: { type: 'default', config: DefaultConfig },
  data: { type: 'empty' },
  filters: {
    maps: { selected: [] },
    keywords: { selected: '' },
    orgUnits: { available: [], selected: [] },
    companies: { available: [], selected: [] },
    categories: { available: [], selected: [] },
    locations: { available: [], selected: [] },
    targetGroups: { available: [], selected: [] },
    languages: { available: [], selected: [] },
  },
  pagination: EmptyPagination,
  jobs: { fetched: [], filtered: [], sorted: [], page: [] },
};

export default State;
